import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-tab',
    templateUrl: './tab.component.html',
    styleUrls: ['./tab.component.scss'],
    host: { '[class.active-tab-height]': 'active' },
})
export class TabComponent {
    @Input() tabId: string;
    @Input() tabTitle: string;
    @Input() isCloseable = false;
    @Input() template;
    @Input() dataContext;
    /**
     * using this components 'active' causes the parent TabsetComponent's 'selectedTab' not being aware of it
     * better use TabsetComponent's 'selectTab' method instead
     */
    @Input() active = false;
}
